import React from 'react';
import { LOGIN_ERROR_COOKIE_NAME } from '../constants';

function getCookieByName(cookieName) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name === cookieName) {
            return decodeURIComponent(value);
        }
    }
    return null;
}

function OktaFailedPage() {
    const errorMessage = getCookieByName(LOGIN_ERROR_COOKIE_NAME);
    return (
        <div>
            <h1 className="mb-3">
                <small>{errorMessage || 'Something went wrong.'}</small>
            </h1>
        </div>
    );
}

export default OktaFailedPage;
